import React, { useEffect, useState } from 'react'

const MyButton = ({ children, className, classNameAdditional, size = 'sm', color = 'green', width, onClick, ...props }) => {

    const [classNameTemp, setClassNameTemp] = useState('')

    useEffect(() => {
        setParams()
    }, [className, size, color, width])

    const setParams = () => {
        let classNameNew = ''

        if (className) {
            classNameNew = className
        } else {
            if (size) {
                classNameNew += 'myBtn__' + size
            }

            // if (color && color === 'green') {
                classNameNew += ' myBtn__' + color
            // }
        }

        if (classNameAdditional) {
            classNameNew += ' ' + classNameAdditional
        }

        setClassNameTemp(classNameNew)
    }

  return (
    <button
        className={classNameTemp}
        onClick={onClick}
        {...props}
    >
        { children }
    </button>
  )
}

export default MyButton